const config = {
    secret_key: process.env.REACT_APP_SECRET_KEY,
}
export default config